// extracted by mini-css-extract-plugin
export default {"deletingEnroll":"DeleteTenantPage_deletingEnroll__FrbpX","deletingTenant":"DeleteTenantPage_deletingTenant__-Yk8N"};